import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Button from '@mui/material/Button'; // Import MUI Button
import { useTranslation } from 'react-i18next';
import Footer from '../footer/Footer'; // Import Footer component
const DeleteAccount = () => {

    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: actually submit email to your API here
        setSubmitted(true);
    };

    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = React.useState(false);
    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            {/* Header */}
            <header className="border-b p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto flex flex-wrap justify-between items-center">
                    <div className="text-2xl md:text-3xl font-bold flex items-center gap-2">
                        <h1>Prodyt</h1>
                    </div>
                    {/* Hamburger Menu Button */}
                    <button
                        className="block md:hidden text-white focus:outline-none"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                    </button>
                    {/* Navigation Menu */}
                    <nav
                        className={`${
                            menuOpen ? 'block' : 'hidden'
                        } absolute top-12 right-4 bg-blue-900 z-10 rounded-md md:static md:w-auto md:bg-transparent md:flex flex-col md:flex-row gap-4 md:gap-6`}
                    >
                        <Link to="/" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Home
                        </Link>
                        <Link to="/about" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            About Us
                        </Link>
                        <Link to="/privacy-policy" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Privacy Policy
                        </Link>
                        <Link to="/help-center" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Help Center
                        </Link>
                        <Link to="/terms-of-service" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Terms of Service
                        </Link>
                        <Link to="/delete-account" className="block text-white px-4 py-2 hover:bg-blue-700 transition duration-300">
                            Delete Account
                        </Link>
                    </nav>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="bg-white border border-gray-300 rounded-lg shadow-lg p-6 md:p-8 max-w-lg md:max-w-3xl w-full">
                    <h1 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6" style={{ color: "#0a3891" }}>
                        {t('delete_account_title')}
                    </h1>
                    <div className="border border-yellow-300 bg-yellow-50 rounded p-4 my-4">
                        <div className="flex items-center mb-2">
                            <svg className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                            </svg>
                            <h3 className="font-bold text-sm md:text-base">Warning</h3>
                        </div>
                        <p className="text-xs md:text-sm">
                            Deleting your account is <span className="font-bold">irreversible</span>. Once deleted, all your data will be permanently removed.
                        </p>
                    </div>

                    <div className="mx-auto my-10">
                        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                            <input
                                type="email"
                                required
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="flex-1 p-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                                type="submit"
                                className="px-4 py-2 bg-blue-800 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                Submit Delete Request
                            </button>
                        </form>

                        {submitted && (
                            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-md">
                                <p className="text-gray-700">
                                    Your data will be deleted within 30 days. If you want to expedite this process, please contact{' '}
                                    <a href="mailto:support@prodyt.com" className="text-blue-600 hover:underline">
                                        support@prodyt.com
                                    </a>.
                                </p>
                            </div>
                        )}
                    </div>
                    {/* <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-8">
                        {t('delete_account_contact_support')}<Link to="#" className="text-blue-600 hover:underline">support@prodyt.com</Link>
                    </p> */}
                </div>
            </main>

            {/* Footer */}
            {/* <footer className="border-t p-4" style={{ backgroundColor: "#0a3891", color: "white" }}>
                <div className="container mx-auto text-center text-xs md:text-sm">
                    <p>&copy; {new Date().getFullYear()} Prodyt. All rights reserved.</p>
                </div>
            </footer> */}
            <Footer />

        </div>
    );
};

export default DeleteAccount;